import {useParams} from 'react-router-dom';
import {useCustomPage} from './use-custom-page';
import {SiteHeader} from '../ui/navigation/site-header';
import {Footer} from '../ui/footer/footer';
import {CustomPageBody} from '@common/custom-page/custom-page-body';
import {PageMetaTags} from '@common/http/page-meta-tags';
import {PageStatus} from '@common/http/page-status';

interface Props {
  slug?: string;
}
export function CustomPageLayout({slug}: Props) {
  const {pageSlug} = useParams();
  const query = useCustomPage(slug || pageSlug!);

  return (
    <div className="flex min-h-full flex-col bg-[#f5f5f7] dark:bg-[#14161a]">
      <PageMetaTags query={query} />
      <SiteHeader />
      <div className="flex-auto">
        {query.data ? (
          <CustomPageBody page={query.data.page} />
        ) : (
          <PageStatus query={query} loaderClassName="mt-80" />
        )}
      </div>
      <Footer className="mx-auto w-full max-w-[1895px] px-[6px] pb-[24px]" />
    </div>
  );
}
